export default __webpack_public_path__ + "static/media/imgg3.b48db3fb.webp";